import {useEffect} from "react";
import {Link} from "react-router-dom";
function NotFound() {
useEffect(() => {
document.title = "404: page not found | LensTalk";
}, []);
return (
<>
<h1>404: Page not found</h1>
<p>the requested URL does not exists on this server</p>
<p>Please double-check the URL and try again</p>
<Link to="/">Take me home</Link>
</>
);
}
export default NotFound;